const compatModules = {};import * as Mod1 from "./discourse/adapters/discourse-post-event-adapter";
compatModules["discourse/adapters/discourse-post-event-adapter"] = Mod1;

export * as discourse$adapters$discourse__post__event__adapter$$__module from "./discourse/adapters/discourse-post-event-adapter";
export {
default as discourse$adapters$discourse__post__event__adapter$$default
} from "./discourse/adapters/discourse-post-event-adapter";
import * as Mod2 from "./discourse/adapters/discourse-post-event-event";
compatModules["discourse/adapters/discourse-post-event-event"] = Mod2;

export * as discourse$adapters$discourse__post__event__event$$__module from "./discourse/adapters/discourse-post-event-event";
export {
default as discourse$adapters$discourse__post__event__event$$default
} from "./discourse/adapters/discourse-post-event-event";
import * as Mod3 from "./discourse/adapters/discourse-post-event-invitee";
compatModules["discourse/adapters/discourse-post-event-invitee"] = Mod3;

export * as discourse$adapters$discourse__post__event__invitee$$__module from "./discourse/adapters/discourse-post-event-invitee";
export {
default as discourse$adapters$discourse__post__event__invitee$$default
} from "./discourse/adapters/discourse-post-event-invitee";
import * as Mod4 from "./discourse/adapters/discourse-post-event-nested-adapter";
compatModules["discourse/adapters/discourse-post-event-nested-adapter"] = Mod4;

export * as discourse$adapters$discourse__post__event__nested__adapter$$__module from "./discourse/adapters/discourse-post-event-nested-adapter";
export {
default as discourse$adapters$discourse__post__event__nested__adapter$$default
} from "./discourse/adapters/discourse-post-event-nested-adapter";
import * as Mod5 from "./discourse/adapters/discourse-post-event-reminder";
compatModules["discourse/adapters/discourse-post-event-reminder"] = Mod5;

export * as discourse$adapters$discourse__post__event__reminder$$__module from "./discourse/adapters/discourse-post-event-reminder";
export {
default as discourse$adapters$discourse__post__event__reminder$$default
} from "./discourse/adapters/discourse-post-event-reminder";
import * as Mod6 from "./discourse/admin-calendar-route-map";
compatModules["discourse/admin-calendar-route-map"] = Mod6;

export * as discourse$admin__calendar__route__map$$__module from "./discourse/admin-calendar-route-map";
export {
default as discourse$admin__calendar__route__map$$default
} from "./discourse/admin-calendar-route-map";
import * as Mod7 from "./discourse/api-initializers/discourse-group-timezones";
compatModules["discourse/api-initializers/discourse-group-timezones"] = Mod7;

export * as discourse$api__initializers$discourse__group__timezones$$__module from "./discourse/api-initializers/discourse-group-timezones";
export {
default as discourse$api__initializers$discourse__group__timezones$$default
} from "./discourse/api-initializers/discourse-group-timezones";
import * as Mod8 from "./discourse/components/admin-holidays-list-item";
compatModules["discourse/components/admin-holidays-list-item"] = Mod8;

export * as discourse$components$admin__holidays__list__item$$__module from "./discourse/components/admin-holidays-list-item";
export {
default as discourse$components$admin__holidays__list__item$$default
} from "./discourse/components/admin-holidays-list-item";
import * as Mod9 from "./discourse/components/admin-holidays-list";
compatModules["discourse/components/admin-holidays-list"] = Mod9;

export * as discourse$components$admin__holidays__list$$__module from "./discourse/components/admin-holidays-list";
export {
default as discourse$components$admin__holidays__list$$default
} from "./discourse/components/admin-holidays-list";
import * as Mod10 from "./discourse/components/bulk-invite-sample-csv-file";
compatModules["discourse/components/bulk-invite-sample-csv-file"] = Mod10;

export * as discourse$components$bulk__invite__sample__csv__file$$__module from "./discourse/components/bulk-invite-sample-csv-file";
export {
default as discourse$components$bulk__invite__sample__csv__file$$default
} from "./discourse/components/bulk-invite-sample-csv-file";
import * as Mod11 from "./discourse/components/category-calendar";
compatModules["discourse/components/category-calendar"] = Mod11;

export * as discourse$components$category__calendar$$__module from "./discourse/components/category-calendar";
export {
default as discourse$components$category__calendar$$default
} from "./discourse/components/category-calendar";
import * as Mod12 from "./discourse/components/compact-event-editor";
compatModules["discourse/components/compact-event-editor"] = Mod12;

export * as discourse$components$compact__event__editor$$__module from "./discourse/components/compact-event-editor";
export {
default as discourse$components$compact__event__editor$$default
} from "./discourse/components/compact-event-editor";
import * as Mod13 from "./discourse/components/composer-event-editor";
compatModules["discourse/components/composer-event-editor"] = Mod13;

export * as discourse$components$composer__event__editor$$__module from "./discourse/components/composer-event-editor";
export {
default as discourse$components$composer__event__editor$$default
} from "./discourse/components/composer-event-editor";
import * as Mod14 from "./discourse/components/csv-uploader";
compatModules["discourse/components/csv-uploader"] = Mod14;

export * as discourse$components$csv__uploader$$__module from "./discourse/components/csv-uploader";
export {
default as discourse$components$csv__uploader$$default
} from "./discourse/components/csv-uploader";
import * as Mod15 from "./discourse/components/discourse-post-event/chat-channel";
compatModules["discourse/components/discourse-post-event/chat-channel"] = Mod15;

export * as discourse$components$discourse__post__event$chat__channel$$__module from "./discourse/components/discourse-post-event/chat-channel";
export {
default as discourse$components$discourse__post__event$chat__channel$$default
} from "./discourse/components/discourse-post-event/chat-channel";
import * as Mod16 from "./discourse/components/discourse-post-event/creator";
compatModules["discourse/components/discourse-post-event/creator"] = Mod16;

export * as discourse$components$discourse__post__event$creator$$__module from "./discourse/components/discourse-post-event/creator";
export {
default as discourse$components$discourse__post__event$creator$$default
} from "./discourse/components/discourse-post-event/creator";
import * as Mod17 from "./discourse/components/discourse-post-event/dates";
compatModules["discourse/components/discourse-post-event/dates"] = Mod17;

export * as discourse$components$discourse__post__event$dates$$__module from "./discourse/components/discourse-post-event/dates";
export {
default as discourse$components$discourse__post__event$dates$$default
} from "./discourse/components/discourse-post-event/dates";
import * as Mod18 from "./discourse/components/discourse-post-event/description";
compatModules["discourse/components/discourse-post-event/description"] = Mod18;

export * as discourse$components$discourse__post__event$description$$__module from "./discourse/components/discourse-post-event/description";
export {
default as discourse$components$discourse__post__event$description$$default
} from "./discourse/components/discourse-post-event/description";
import * as Mod19 from "./discourse/components/discourse-post-event/event-status";
compatModules["discourse/components/discourse-post-event/event-status"] = Mod19;

export * as discourse$components$discourse__post__event$event__status$$__module from "./discourse/components/discourse-post-event/event-status";
export {
default as discourse$components$discourse__post__event$event__status$$default
} from "./discourse/components/discourse-post-event/event-status";
import * as Mod20 from "./discourse/components/discourse-post-event/image";
compatModules["discourse/components/discourse-post-event/image"] = Mod20;

export * as discourse$components$discourse__post__event$image$$__module from "./discourse/components/discourse-post-event/image";
export {
default as discourse$components$discourse__post__event$image$$default
} from "./discourse/components/discourse-post-event/image";
import * as Mod21 from "./discourse/components/discourse-post-event/index";
compatModules["discourse/components/discourse-post-event/index"] = Mod21;

export * as discourse$components$discourse__post__event$index$$__module from "./discourse/components/discourse-post-event/index";
export {
default as discourse$components$discourse__post__event$index$$default,
default as discourse$components$discourse__post__event$$default
} from "./discourse/components/discourse-post-event/index";
import * as Mod22 from "./discourse/components/discourse-post-event/invitee";
compatModules["discourse/components/discourse-post-event/invitee"] = Mod22;

export * as discourse$components$discourse__post__event$invitee$$__module from "./discourse/components/discourse-post-event/invitee";
export {
default as discourse$components$discourse__post__event$invitee$$default
} from "./discourse/components/discourse-post-event/invitee";
import * as Mod23 from "./discourse/components/discourse-post-event/invitees";
compatModules["discourse/components/discourse-post-event/invitees"] = Mod23;

export * as discourse$components$discourse__post__event$invitees$$__module from "./discourse/components/discourse-post-event/invitees";
export {
default as discourse$components$discourse__post__event$invitees$$default
} from "./discourse/components/discourse-post-event/invitees";
import * as Mod24 from "./discourse/components/discourse-post-event/location";
compatModules["discourse/components/discourse-post-event/location"] = Mod24;

export * as discourse$components$discourse__post__event$location$$__module from "./discourse/components/discourse-post-event/location";
export {
default as discourse$components$discourse__post__event$location$$default
} from "./discourse/components/discourse-post-event/location";
import * as Mod25 from "./discourse/components/discourse-post-event/more-menu";
compatModules["discourse/components/discourse-post-event/more-menu"] = Mod25;

export * as discourse$components$discourse__post__event$more__menu$$__module from "./discourse/components/discourse-post-event/more-menu";
export {
default as discourse$components$discourse__post__event$more__menu$$default
} from "./discourse/components/discourse-post-event/more-menu";
import * as Mod26 from "./discourse/components/discourse-post-event/status";
compatModules["discourse/components/discourse-post-event/status"] = Mod26;

export * as discourse$components$discourse__post__event$status$$__module from "./discourse/components/discourse-post-event/status";
export {
default as discourse$components$discourse__post__event$status$$default
} from "./discourse/components/discourse-post-event/status";
import * as Mod27 from "./discourse/components/discourse-post-event/url";
compatModules["discourse/components/discourse-post-event/url"] = Mod27;

export * as discourse$components$discourse__post__event$url$$__module from "./discourse/components/discourse-post-event/url";
export {
default as discourse$components$discourse__post__event$url$$default
} from "./discourse/components/discourse-post-event/url";
import * as Mod28 from "./discourse/components/event-date";
compatModules["discourse/components/event-date"] = Mod28;

export * as discourse$components$event__date$$__module from "./discourse/components/event-date";
export {
default as discourse$components$event__date$$default
} from "./discourse/components/event-date";
import * as Mod29 from "./discourse/components/event-node-view";
compatModules["discourse/components/event-node-view"] = Mod29;

export * as discourse$components$event__node__view$$__module from "./discourse/components/event-node-view";
export {
default as discourse$components$event__node__view$$default
} from "./discourse/components/event-node-view";
import * as Mod30 from "./discourse/components/full-calendar";
compatModules["discourse/components/full-calendar"] = Mod30;

export * as discourse$components$full__calendar$$__module from "./discourse/components/full-calendar";
export {
default as discourse$components$full__calendar$$default
} from "./discourse/components/full-calendar";
import * as Mod31 from "./discourse/components/group-timezones/index";
compatModules["discourse/components/group-timezones/index"] = Mod31;

export * as discourse$components$group__timezones$index$$__module from "./discourse/components/group-timezones/index";
export {
default as discourse$components$group__timezones$index$$default,
default as discourse$components$group__timezones$$default
} from "./discourse/components/group-timezones/index";
import * as Mod32 from "./discourse/components/group-timezones/new-day";
compatModules["discourse/components/group-timezones/new-day"] = Mod32;

export * as discourse$components$group__timezones$new__day$$__module from "./discourse/components/group-timezones/new-day";
export {
default as discourse$components$group__timezones$new__day$$default
} from "./discourse/components/group-timezones/new-day";
import * as Mod33 from "./discourse/components/group-timezones/time-traveller";
compatModules["discourse/components/group-timezones/time-traveller"] = Mod33;

export * as discourse$components$group__timezones$time__traveller$$__module from "./discourse/components/group-timezones/time-traveller";
export {
default as discourse$components$group__timezones$time__traveller$$default
} from "./discourse/components/group-timezones/time-traveller";
import * as Mod34 from "./discourse/components/group-timezones/timezone";
compatModules["discourse/components/group-timezones/timezone"] = Mod34;

export * as discourse$components$group__timezones$timezone$$__module from "./discourse/components/group-timezones/timezone";
export {
default as discourse$components$group__timezones$timezone$$default
} from "./discourse/components/group-timezones/timezone";
import * as Mod35 from "./discourse/components/livestream/embeddable-chat-channel";
compatModules["discourse/components/livestream/embeddable-chat-channel"] = Mod35;

export * as discourse$components$livestream$embeddable__chat__channel$$__module from "./discourse/components/livestream/embeddable-chat-channel";
export {
default as discourse$components$livestream$embeddable__chat__channel$$default
} from "./discourse/components/livestream/embeddable-chat-channel";
import * as Mod36 from "./discourse/components/livestream/mobile-livestream-chat-icon";
compatModules["discourse/components/livestream/mobile-livestream-chat-icon"] = Mod36;

export * as discourse$components$livestream$mobile__livestream__chat__icon$$__module from "./discourse/components/livestream/mobile-livestream-chat-icon";
export {
default as discourse$components$livestream$mobile__livestream__chat__icon$$default
} from "./discourse/components/livestream/mobile-livestream-chat-icon";
import * as Mod37 from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
compatModules["discourse/components/livestream/modal/mobile-embeddable-chat-modal"] = Mod37;

export * as discourse$components$livestream$modal$mobile__embeddable__chat__modal$$__module from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
export {
default as discourse$components$livestream$modal$mobile__embeddable__chat__modal$$default
} from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
import * as Mod38 from "./discourse/components/livestream/responsive-livestream-chat-icon";
compatModules["discourse/components/livestream/responsive-livestream-chat-icon"] = Mod38;

export * as discourse$components$livestream$responsive__livestream__chat__icon$$__module from "./discourse/components/livestream/responsive-livestream-chat-icon";
export {
default as discourse$components$livestream$responsive__livestream__chat__icon$$default
} from "./discourse/components/livestream/responsive-livestream-chat-icon";
import * as Mod39 from "./discourse/components/modal/post-event-builder";
compatModules["discourse/components/modal/post-event-builder"] = Mod39;

export * as discourse$components$modal$post__event__builder$$__module from "./discourse/components/modal/post-event-builder";
export {
default as discourse$components$modal$post__event__builder$$default
} from "./discourse/components/modal/post-event-builder";
import * as Mod40 from "./discourse/components/modal/post-event-bulk-invite";
compatModules["discourse/components/modal/post-event-bulk-invite"] = Mod40;

export * as discourse$components$modal$post__event__bulk__invite$$__module from "./discourse/components/modal/post-event-bulk-invite";
export {
default as discourse$components$modal$post__event__bulk__invite$$default
} from "./discourse/components/modal/post-event-bulk-invite";
import * as Mod41 from "./discourse/components/modal/post-event-invite-user-or-group";
compatModules["discourse/components/modal/post-event-invite-user-or-group"] = Mod41;

export * as discourse$components$modal$post__event__invite__user__or__group$$__module from "./discourse/components/modal/post-event-invite-user-or-group";
export {
default as discourse$components$modal$post__event__invite__user__or__group$$default
} from "./discourse/components/modal/post-event-invite-user-or-group";
import * as Mod42 from "./discourse/components/modal/post-event-invitees/index";
compatModules["discourse/components/modal/post-event-invitees/index"] = Mod42;

export * as discourse$components$modal$post__event__invitees$index$$__module from "./discourse/components/modal/post-event-invitees/index";
export {
default as discourse$components$modal$post__event__invitees$index$$default,
default as discourse$components$modal$post__event__invitees$$default
} from "./discourse/components/modal/post-event-invitees/index";
import * as Mod43 from "./discourse/components/modal/post-event-invitees/user";
compatModules["discourse/components/modal/post-event-invitees/user"] = Mod43;

export * as discourse$components$modal$post__event__invitees$user$$__module from "./discourse/components/modal/post-event-invitees/user";
export {
default as discourse$components$modal$post__event__invitees$user$$default
} from "./discourse/components/modal/post-event-invitees/user";
import * as Mod44 from "./discourse/components/post-calendar";
compatModules["discourse/components/post-calendar"] = Mod44;

export * as discourse$components$post__calendar$$__module from "./discourse/components/post-calendar";
export {
default as discourse$components$post__calendar$$default
} from "./discourse/components/post-calendar";
import * as Mod45 from "./discourse/components/region-input";
compatModules["discourse/components/region-input"] = Mod45;

export * as discourse$components$region__input$$__module from "./discourse/components/region-input";
export {
default as discourse$components$region__input$$default
} from "./discourse/components/region-input";
import * as Mod46 from "./discourse/components/toggle-invitees";
compatModules["discourse/components/toggle-invitees"] = Mod46;

export * as discourse$components$toggle__invitees$$__module from "./discourse/components/toggle-invitees";
export {
default as discourse$components$toggle__invitees$$default
} from "./discourse/components/toggle-invitees";
import * as Mod47 from "./discourse/components/upcoming-events-calendar";
compatModules["discourse/components/upcoming-events-calendar"] = Mod47;

export * as discourse$components$upcoming__events__calendar$$__module from "./discourse/components/upcoming-events-calendar";
export {
default as discourse$components$upcoming__events__calendar$$default
} from "./discourse/components/upcoming-events-calendar";
import * as Mod48 from "./discourse/components/upcoming-events-list";
compatModules["discourse/components/upcoming-events-list"] = Mod48;

export * as discourse$components$upcoming__events__list$$__module from "./discourse/components/upcoming-events-list";
export {
DEFAULT_TIME_FORMAT as discourse$components$upcoming__events__list$$DEFAULT_TIME_FORMAT,
default as discourse$components$upcoming__events__list$$default
} from "./discourse/components/upcoming-events-list";
import * as Mod49 from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
compatModules["discourse/connectors/before-main-outlet/embeddable-chat-channel-connector"] = Mod49;

export * as discourse$connectors$before__main__outlet$embeddable__chat__channel__connector$$__module from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
export {
default as discourse$connectors$before__main__outlet$embeddable__chat__channel__connector$$default
} from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
import * as Mod50 from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
compatModules["discourse/connectors/before-topic-list-body/category-calendar"] = Mod50;

export * as discourse$connectors$before__topic__list__body$category__calendar$$__module from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
export {
default as discourse$connectors$before__topic__list__body$category__calendar$$default
} from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
import * as Mod51 from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
compatModules["discourse/connectors/calendar-subscriptions-feeds/event-feeds"] = Mod51;

export * as discourse$connectors$calendar__subscriptions__feeds$event__feeds$$__module from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
export {
default as discourse$connectors$calendar__subscriptions__feeds$event__feeds$$default
} from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
import * as Mod52 from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/show-event-category-sorting-settings"] = Mod52;

export * as discourse$connectors$category__custom__settings$show__event__category__sorting__settings$$__module from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$show__event__category__sorting__settings$$default
} from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
import * as Mod53 from "./discourse/connectors/chat-join-channel-button/join-channel-message.gjs";
compatModules["discourse/connectors/chat-join-channel-button/join-channel-message"] = Mod53;

export * as discourse$connectors$chat__join__channel__button$join__channel__message$$__module from "./discourse/connectors/chat-join-channel-button/join-channel-message.gjs";
export {
default as discourse$connectors$chat__join__channel__button$join__channel__message$$default
} from "./discourse/connectors/chat-join-channel-button/join-channel-message.gjs";
import * as Mod54 from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
compatModules["discourse/connectors/discovery-list-container-top/category-events-calendar"] = Mod54;

export * as discourse$connectors$discovery__list__container__top$category__events__calendar$$__module from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
export {
default as discourse$connectors$discovery__list__container__top$category__events__calendar$$default
} from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
import * as Mod55 from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
compatModules["discourse/connectors/header-topic-title-suffix/event-date-container"] = Mod55;

export * as discourse$connectors$header__topic__title__suffix$event__date__container$$__module from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
export {
default as discourse$connectors$header__topic__title__suffix$event__date__container$$default
} from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
import * as Mod56 from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
compatModules["discourse/connectors/topic-list-after-title/event-badge"] = Mod56;

export * as discourse$connectors$topic__list__after__title$event__badge$$__module from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
export {
default as discourse$connectors$topic__list__after__title$event__badge$$default
} from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
import * as Mod57 from "./discourse/connectors/user-custom-preferences/region.gjs";
compatModules["discourse/connectors/user-custom-preferences/region"] = Mod57;

export * as discourse$connectors$user__custom__preferences$region$$__module from "./discourse/connectors/user-custom-preferences/region.gjs";
export {
default as discourse$connectors$user__custom__preferences$region$$default
} from "./discourse/connectors/user-custom-preferences/region.gjs";
import * as Mod58 from "./discourse/controllers/admin-plugins/show/discourse-calendar-holidays";
compatModules["discourse/controllers/admin-plugins/show/discourse-calendar-holidays"] = Mod58;

export * as discourse$controllers$admin__plugins$show$discourse__calendar__holidays$$__module from "./discourse/controllers/admin-plugins/show/discourse-calendar-holidays";
export {
default as discourse$controllers$admin__plugins$show$discourse__calendar__holidays$$default
} from "./discourse/controllers/admin-plugins/show/discourse-calendar-holidays";
import * as Mod59 from "./discourse/controllers/discourse-post-event-upcoming-events";
compatModules["discourse/controllers/discourse-post-event-upcoming-events"] = Mod59;

export * as discourse$controllers$discourse__post__event__upcoming__events$$__module from "./discourse/controllers/discourse-post-event-upcoming-events";
export {
default as discourse$controllers$discourse__post__event__upcoming__events$$default
} from "./discourse/controllers/discourse-post-event-upcoming-events";
import * as Mod60 from "./discourse/controllers/discourse-post-event-upcoming-events/index";
compatModules["discourse/controllers/discourse-post-event-upcoming-events/index"] = Mod60;

export * as discourse$controllers$discourse__post__event__upcoming__events$index$$__module from "./discourse/controllers/discourse-post-event-upcoming-events/index";
export {
default as discourse$controllers$discourse__post__event__upcoming__events$index$$default
} from "./discourse/controllers/discourse-post-event-upcoming-events/index";
import * as Mod61 from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
compatModules["discourse/controllers/discourse-post-event-upcoming-events/mine"] = Mod61;

export * as discourse$controllers$discourse__post__event__upcoming__events$mine$$__module from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
export {
default as discourse$controllers$discourse__post__event__upcoming__events$mine$$default
} from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
import * as Mod62 from "./discourse/discourse-event-upcoming-events-route-map";
compatModules["discourse/discourse-event-upcoming-events-route-map"] = Mod62;

export * as discourse$discourse__event__upcoming__events__route__map$$__module from "./discourse/discourse-event-upcoming-events-route-map";
export {
default as discourse$discourse__event__upcoming__events__route__map$$default
} from "./discourse/discourse-event-upcoming-events-route-map";
import * as Mod63 from "./discourse/helpers/format-event-name";
compatModules["discourse/helpers/format-event-name"] = Mod63;

export * as discourse$helpers$format__event__name$$__module from "./discourse/helpers/format-event-name";
export {
formatEventName as discourse$helpers$format__event__name$$formatEventName
} from "./discourse/helpers/format-event-name";
import * as Mod64 from "./discourse/helpers/format-future-date";
compatModules["discourse/helpers/format-future-date"] = Mod64;

export * as discourse$helpers$format__future__date$$__module from "./discourse/helpers/format-future-date";
export {
default as discourse$helpers$format__future__date$$default
} from "./discourse/helpers/format-future-date";
import * as Mod65 from "./discourse/initializers/add-create-event-composer-action";
compatModules["discourse/initializers/add-create-event-composer-action"] = Mod65;

export * as discourse$initializers$add__create__event__composer__action$$__module from "./discourse/initializers/add-create-event-composer-action";
export {
default as discourse$initializers$add__create__event__composer__action$$default
} from "./discourse/initializers/add-create-event-composer-action";
import * as Mod66 from "./discourse/initializers/add-event-ui-builder";
compatModules["discourse/initializers/add-event-ui-builder"] = Mod66;

export * as discourse$initializers$add__event__ui__builder$$__module from "./discourse/initializers/add-event-ui-builder";
export {
default as discourse$initializers$add__event__ui__builder$$default
} from "./discourse/initializers/add-event-ui-builder";
import * as Mod67 from "./discourse/initializers/add-events-create-topic-button";
compatModules["discourse/initializers/add-events-create-topic-button"] = Mod67;

export * as discourse$initializers$add__events__create__topic__button$$__module from "./discourse/initializers/add-events-create-topic-button";
export {
default as discourse$initializers$add__events__create__topic__button$$default
} from "./discourse/initializers/add-events-create-topic-button";
import * as Mod68 from "./discourse/initializers/add-upcoming-events-to-sidebar";
compatModules["discourse/initializers/add-upcoming-events-to-sidebar"] = Mod68;

export * as discourse$initializers$add__upcoming__events__to__sidebar$$__module from "./discourse/initializers/add-upcoming-events-to-sidebar";
export {
default as discourse$initializers$add__upcoming__events__to__sidebar$$default
} from "./discourse/initializers/add-upcoming-events-to-sidebar";
import * as Mod69 from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
compatModules["discourse/initializers/calendar-admin-plugin-configuration-nav"] = Mod69;

export * as discourse$initializers$calendar__admin__plugin__configuration__nav$$__module from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
export {
default as discourse$initializers$calendar__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
import * as Mod70 from "./discourse/initializers/disable-sort";
compatModules["discourse/initializers/disable-sort"] = Mod70;

export * as discourse$initializers$disable__sort$$__module from "./discourse/initializers/disable-sort";
export {
default as discourse$initializers$disable__sort$$default
} from "./discourse/initializers/disable-sort";
import * as Mod71 from "./discourse/initializers/discourse-calendar";
compatModules["discourse/initializers/discourse-calendar"] = Mod71;

export * as discourse$initializers$discourse__calendar$$__module from "./discourse/initializers/discourse-calendar";
export {
default as discourse$initializers$discourse__calendar$$default
} from "./discourse/initializers/discourse-calendar";
import * as Mod72 from "./discourse/initializers/discourse-post-event-decorator";
compatModules["discourse/initializers/discourse-post-event-decorator"] = Mod72;

export * as discourse$initializers$discourse__post__event__decorator$$__module from "./discourse/initializers/discourse-post-event-decorator";
export {
default as discourse$initializers$discourse__post__event__decorator$$default
} from "./discourse/initializers/discourse-post-event-decorator";
import * as Mod73 from "./discourse/initializers/event-relative-date";
compatModules["discourse/initializers/event-relative-date"] = Mod73;

export * as discourse$initializers$event__relative__date$$__module from "./discourse/initializers/event-relative-date";
export {
default as discourse$initializers$event__relative__date$$default
} from "./discourse/initializers/event-relative-date";
import * as Mod74 from "./discourse/initializers/livestream-chat-overrides";
compatModules["discourse/initializers/livestream-chat-overrides"] = Mod74;

export * as discourse$initializers$livestream__chat__overrides$$__module from "./discourse/initializers/livestream-chat-overrides";
export {
default as discourse$initializers$livestream__chat__overrides$$default
} from "./discourse/initializers/livestream-chat-overrides";
import * as Mod75 from "./discourse/lib/calendar-locale";
compatModules["discourse/lib/calendar-locale"] = Mod75;

export * as discourse$lib$calendar__locale$$__module from "./discourse/lib/calendar-locale";
export {
getCurrentBcp47Locale as discourse$lib$calendar__locale$$getCurrentBcp47Locale,
getCalendarButtonsText as discourse$lib$calendar__locale$$getCalendarButtonsText
} from "./discourse/lib/calendar-locale";
import * as Mod76 from "./discourse/lib/calendar-view-helper";
compatModules["discourse/lib/calendar-view-helper"] = Mod76;

export * as discourse$lib$calendar__view__helper$$__module from "./discourse/lib/calendar-view-helper";
export {
normalizeViewForCalendar as discourse$lib$calendar__view__helper$$normalizeViewForCalendar,
normalizeViewForRoute as discourse$lib$calendar__view__helper$$normalizeViewForRoute
} from "./discourse/lib/calendar-view-helper";
import * as Mod77 from "./discourse/lib/colors";
compatModules["discourse/lib/colors"] = Mod77;

export * as discourse$lib$colors$$__module from "./discourse/lib/colors";
export {
stringToColor as discourse$lib$colors$$stringToColor,
colorToHex as discourse$lib$colors$$colorToHex,
contrastColor as discourse$lib$colors$$contrastColor
} from "./discourse/lib/colors";
import * as Mod78 from "./discourse/lib/discourse-markdown/discourse-calendar";
compatModules["discourse/lib/discourse-markdown/discourse-calendar"] = Mod78;

export * as discourse$lib$discourse__markdown$discourse__calendar$$__module from "./discourse/lib/discourse-markdown/discourse-calendar";
export {
setup as discourse$lib$discourse__markdown$discourse__calendar$$setup
} from "./discourse/lib/discourse-markdown/discourse-calendar";
import * as Mod79 from "./discourse/lib/discourse-markdown/discourse-post-event-block";
compatModules["discourse/lib/discourse-markdown/discourse-post-event-block"] = Mod79;

export * as discourse$lib$discourse__markdown$discourse__post__event__block$$__module from "./discourse/lib/discourse-markdown/discourse-post-event-block";
export {
setup as discourse$lib$discourse__markdown$discourse__post__event__block$$setup
} from "./discourse/lib/discourse-markdown/discourse-post-event-block";
import * as Mod80 from "./discourse/lib/discourse-markdown/livestream-preview";
compatModules["discourse/lib/discourse-markdown/livestream-preview"] = Mod80;

export * as discourse$lib$discourse__markdown$livestream__preview$$__module from "./discourse/lib/discourse-markdown/livestream-preview";
export {
setup as discourse$lib$discourse__markdown$livestream__preview$$setup
} from "./discourse/lib/discourse-markdown/livestream-preview";
import * as Mod81 from "./discourse/lib/event-preview";
compatModules["discourse/lib/event-preview"] = Mod81;

export * as discourse$lib$event__preview$$__module from "./discourse/lib/event-preview";
export {
buildEventPreview as discourse$lib$event__preview$$buildEventPreview
} from "./discourse/lib/event-preview";
import * as Mod82 from "./discourse/lib/event-recurrence";
compatModules["discourse/lib/event-recurrence"] = Mod82;

export * as discourse$lib$event__recurrence$$__module from "./discourse/lib/event-recurrence";
export {
recurrenceRef as discourse$lib$event__recurrence$$recurrenceRef,
recurrenceContext as discourse$lib$event__recurrence$$recurrenceContext
} from "./discourse/lib/event-recurrence";
import * as Mod83 from "./discourse/lib/event-relative-date";
compatModules["discourse/lib/event-relative-date"] = Mod83;

export * as discourse$lib$event__relative__date$$__module from "./discourse/lib/event-relative-date";
export {
default as discourse$lib$event__relative__date$$default
} from "./discourse/lib/event-relative-date";
import * as Mod84 from "./discourse/lib/format-event-for-calendar";
compatModules["discourse/lib/format-event-for-calendar"] = Mod84;

export * as discourse$lib$format__event__for__calendar$$__module from "./discourse/lib/format-event-for-calendar";
export {
default as discourse$lib$format__event__for__calendar$$default
} from "./discourse/lib/format-event-for-calendar";
import * as Mod85 from "./discourse/lib/full-calendar-default-options";
compatModules["discourse/lib/full-calendar-default-options"] = Mod85;

export * as discourse$lib$full__calendar__default__options$$__module from "./discourse/lib/full-calendar-default-options";
export {
default as discourse$lib$full__calendar__default__options$$default
} from "./discourse/lib/full-calendar-default-options";
import * as Mod86 from "./discourse/lib/guess-best-date-format";
compatModules["discourse/lib/guess-best-date-format"] = Mod86;

export * as discourse$lib$guess__best__date__format$$__module from "./discourse/lib/guess-best-date-format";
export {
isNotFullDayEvent as discourse$lib$guess__best__date__format$$isNotFullDayEvent,
default as discourse$lib$guess__best__date__format$$default
} from "./discourse/lib/guess-best-date-format";
import * as Mod87 from "./discourse/lib/open-event-composer";
compatModules["discourse/lib/open-event-composer"] = Mod87;

export * as discourse$lib$open__event__composer$$__module from "./discourse/lib/open-event-composer";
export {
default as discourse$lib$open__event__composer$$default
} from "./discourse/lib/open-event-composer";
import * as Mod88 from "./discourse/lib/raw-event-helper";
compatModules["discourse/lib/raw-event-helper"] = Mod88;

export * as discourse$lib$raw__event__helper$$__module from "./discourse/lib/raw-event-helper";
export {
defaultReminderFor as discourse$lib$raw__event__helper$$defaultReminderFor,
reminderToBBCode as discourse$lib$raw__event__helper$$reminderToBBCode,
attendanceTransition as discourse$lib$raw__event__helper$$attendanceTransition,
reconcileDefaultReminder as discourse$lib$raw__event__helper$$reconcileDefaultReminder,
buildParams as discourse$lib$raw__event__helper$$buildParams,
parseEventBlock as discourse$lib$raw__event__helper$$parseEventBlock,
buildEventBlock as discourse$lib$raw__event__helper$$buildEventBlock,
getCustomFieldNames as discourse$lib$raw__event__helper$$getCustomFieldNames,
defaultEventState as discourse$lib$raw__event__helper$$defaultEventState,
parseEventAttrs as discourse$lib$raw__event__helper$$parseEventAttrs,
stateToEventInput as discourse$lib$raw__event__helper$$stateToEventInput,
parseReminders as discourse$lib$raw__event__helper$$parseReminders,
replaceRaw as discourse$lib$raw__event__helper$$replaceRaw,
camelCase as discourse$lib$raw__event__helper$$camelCase,
removeEvent as discourse$lib$raw__event__helper$$removeEvent,
buildEventSkeleton as discourse$lib$raw__event__helper$$buildEventSkeleton
} from "./discourse/lib/raw-event-helper";
import * as Mod89 from "./discourse/lib/regions";
compatModules["discourse/lib/regions"] = Mod89;

export * as discourse$lib$regions$$__module from "./discourse/lib/regions";
export {
HOLIDAY_REGIONS as discourse$lib$regions$$HOLIDAY_REGIONS,
TIME_ZONE_TO_REGION as discourse$lib$regions$$TIME_ZONE_TO_REGION
} from "./discourse/lib/regions";
import * as Mod90 from "./discourse/lib/round-time";
compatModules["discourse/lib/round-time"] = Mod90;

export * as discourse$lib$round__time$$__module from "./discourse/lib/round-time";
export {
default as discourse$lib$round__time$$default
} from "./discourse/lib/round-time";
import * as Mod91 from "./discourse/models/discourse-post-event-event-stats";
compatModules["discourse/models/discourse-post-event-event-stats"] = Mod91;

export * as discourse$models$discourse__post__event__event__stats$$__module from "./discourse/models/discourse-post-event-event-stats";
export {
default as discourse$models$discourse__post__event__event__stats$$default
} from "./discourse/models/discourse-post-event-event-stats";
import * as Mod92 from "./discourse/models/discourse-post-event-event";
compatModules["discourse/models/discourse-post-event-event"] = Mod92;

export * as discourse$models$discourse__post__event__event$$__module from "./discourse/models/discourse-post-event-event";
export {
default as discourse$models$discourse__post__event__event$$default
} from "./discourse/models/discourse-post-event-event";
import * as Mod93 from "./discourse/models/discourse-post-event-invitee";
compatModules["discourse/models/discourse-post-event-invitee"] = Mod93;

export * as discourse$models$discourse__post__event__invitee$$__module from "./discourse/models/discourse-post-event-invitee";
export {
default as discourse$models$discourse__post__event__invitee$$default
} from "./discourse/models/discourse-post-event-invitee";
import * as Mod94 from "./discourse/models/discourse-post-event-invitees";
compatModules["discourse/models/discourse-post-event-invitees"] = Mod94;

export * as discourse$models$discourse__post__event__invitees$$__module from "./discourse/models/discourse-post-event-invitees";
export {
default as discourse$models$discourse__post__event__invitees$$default
} from "./discourse/models/discourse-post-event-invitees";
import * as Mod95 from "./discourse/models/discourse-post-event-reminder";
compatModules["discourse/models/discourse-post-event-reminder"] = Mod95;

export * as discourse$models$discourse__post__event__reminder$$__module from "./discourse/models/discourse-post-event-reminder";
export {
default as discourse$models$discourse__post__event__reminder$$default
} from "./discourse/models/discourse-post-event-reminder";
import * as Mod96 from "./discourse/pre-initializers/rich-editor-extension";
compatModules["discourse/pre-initializers/rich-editor-extension"] = Mod96;

export * as discourse$pre__initializers$rich__editor__extension$$__module from "./discourse/pre-initializers/rich-editor-extension";
export {
EVENT_ATTRIBUTES as discourse$pre__initializers$rich__editor__extension$$EVENT_ATTRIBUTES,
default as discourse$pre__initializers$rich__editor__extension$$default
} from "./discourse/pre-initializers/rich-editor-extension";
import * as Mod97 from "./discourse/pre-initializers/transformers";
compatModules["discourse/pre-initializers/transformers"] = Mod97;

export * as discourse$pre__initializers$transformers$$__module from "./discourse/pre-initializers/transformers";
export {
default as discourse$pre__initializers$transformers$$default
} from "./discourse/pre-initializers/transformers";
import * as Mod98 from "./discourse/routes/discourse-post-event-upcoming-events";
compatModules["discourse/routes/discourse-post-event-upcoming-events"] = Mod98;

export * as discourse$routes$discourse__post__event__upcoming__events$$__module from "./discourse/routes/discourse-post-event-upcoming-events";
export {
default as discourse$routes$discourse__post__event__upcoming__events$$default
} from "./discourse/routes/discourse-post-event-upcoming-events";
import * as Mod99 from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
compatModules["discourse/routes/discourse-post-event-upcoming-events/default-index"] = Mod99;

export * as discourse$routes$discourse__post__event__upcoming__events$default__index$$__module from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
export {
default as discourse$routes$discourse__post__event__upcoming__events$default__index$$default
} from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
import * as Mod100 from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
compatModules["discourse/routes/discourse-post-event-upcoming-events/default-mine"] = Mod100;

export * as discourse$routes$discourse__post__event__upcoming__events$default__mine$$__module from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
export {
default as discourse$routes$discourse__post__event__upcoming__events$default__mine$$default
} from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
import * as Mod101 from "./discourse/routes/discourse-post-event-upcoming-events/index";
compatModules["discourse/routes/discourse-post-event-upcoming-events/index"] = Mod101;

export * as discourse$routes$discourse__post__event__upcoming__events$index$$__module from "./discourse/routes/discourse-post-event-upcoming-events/index";
export {
default as discourse$routes$discourse__post__event__upcoming__events$index$$default
} from "./discourse/routes/discourse-post-event-upcoming-events/index";
import * as Mod102 from "./discourse/routes/discourse-post-event-upcoming-events/mine";
compatModules["discourse/routes/discourse-post-event-upcoming-events/mine"] = Mod102;

export * as discourse$routes$discourse__post__event__upcoming__events$mine$$__module from "./discourse/routes/discourse-post-event-upcoming-events/mine";
export {
default as discourse$routes$discourse__post__event__upcoming__events$mine$$default
} from "./discourse/routes/discourse-post-event-upcoming-events/mine";
import * as Mod103 from "./discourse/services/create-event-composer";
compatModules["discourse/services/create-event-composer"] = Mod103;

export * as discourse$services$create__event__composer$$__module from "./discourse/services/create-event-composer";
export {
default as discourse$services$create__event__composer$$default
} from "./discourse/services/create-event-composer";
import * as Mod104 from "./discourse/services/discourse-post-event-api";
compatModules["discourse/services/discourse-post-event-api"] = Mod104;

export * as discourse$services$discourse__post__event__api$$__module from "./discourse/services/discourse-post-event-api";
export {
default as discourse$services$discourse__post__event__api$$default
} from "./discourse/services/discourse-post-event-api";
import * as Mod105 from "./discourse/services/discourse-post-event-service";
compatModules["discourse/services/discourse-post-event-service"] = Mod105;

export * as discourse$services$discourse__post__event__service$$__module from "./discourse/services/discourse-post-event-service";
export {
default as discourse$services$discourse__post__event__service$$default
} from "./discourse/services/discourse-post-event-service";
import * as Mod106 from "./discourse/services/embeddable-chat";
compatModules["discourse/services/embeddable-chat"] = Mod106;

export * as discourse$services$embeddable__chat$$__module from "./discourse/services/embeddable-chat";
export {
LIVESTREAM_TAG_NAME as discourse$services$embeddable__chat$$LIVESTREAM_TAG_NAME,
default as discourse$services$embeddable__chat$$default
} from "./discourse/services/embeddable-chat";
import * as Mod107 from "./discourse/services/post-calendar";
compatModules["discourse/services/post-calendar"] = Mod107;

export * as discourse$services$post__calendar$$__module from "./discourse/services/post-calendar";
export {
default as discourse$services$post__calendar$$default
} from "./discourse/services/post-calendar";
import * as Mod108 from "./discourse/templates/admin-plugins/show/discourse-calendar-holidays";
compatModules["discourse/templates/admin-plugins/show/discourse-calendar-holidays"] = Mod108;

export * as discourse$templates$admin__plugins$show$discourse__calendar__holidays$$__module from "./discourse/templates/admin-plugins/show/discourse-calendar-holidays";
export {
default as discourse$templates$admin__plugins$show$discourse__calendar__holidays$$default
} from "./discourse/templates/admin-plugins/show/discourse-calendar-holidays";
import * as Mod109 from "./discourse/templates/discourse-post-event-upcoming-events";
compatModules["discourse/templates/discourse-post-event-upcoming-events"] = Mod109;

export * as discourse$templates$discourse__post__event__upcoming__events$$__module from "./discourse/templates/discourse-post-event-upcoming-events";
export {
default as discourse$templates$discourse__post__event__upcoming__events$$default
} from "./discourse/templates/discourse-post-event-upcoming-events";
import * as Mod110 from "./discourse/templates/discourse-post-event-upcoming-events/index";
compatModules["discourse/templates/discourse-post-event-upcoming-events/index"] = Mod110;

export * as discourse$templates$discourse__post__event__upcoming__events$index$$__module from "./discourse/templates/discourse-post-event-upcoming-events/index";
export {
default as discourse$templates$discourse__post__event__upcoming__events$index$$default
} from "./discourse/templates/discourse-post-event-upcoming-events/index";
import * as Mod111 from "./discourse/templates/discourse-post-event-upcoming-events/mine";
compatModules["discourse/templates/discourse-post-event-upcoming-events/mine"] = Mod111;

export * as discourse$templates$discourse__post__event__upcoming__events$mine$$__module from "./discourse/templates/discourse-post-event-upcoming-events/mine";
export {
default as discourse$templates$discourse__post__event__upcoming__events$mine$$default
} from "./discourse/templates/discourse-post-event-upcoming-events/mine";
export default compatModules;
